import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { iWebFormField } from '../../../webForms/schema';
import { useDispatch } from 'react-redux';
import { ConvertZ } from '../../../helpers/helperFunctions';
interface IShowWebformDetailsProps {
    webformFieldList: any[];
    values : string;
}
const WebFormValues = (props:IShowWebformDetailsProps)=>{
    const {values="{}",webformFieldList=[]} = props;
    const [value, setValue] = useState<any>({});
    const [editVal,setEditVal] = useState<any>([]);
    
    useEffect(()=>{
        // debugger;
        const tempValues = JSON.parse(values);
        if(tempValues.isNew){
            const tempObj: Record<string, string> = {};
            tempValues.webformValues = tempValues.webformValues.map((i:iWebFormField)=>{
                
                    tempObj[`${i.fieldId}`] = i.value ?? '';
                    return i;
            })
            setEditVal(tempValues.webformValues)
            setValue(tempObj)
        } else {
            setEditVal(webformFieldList.filter((i:any)=>(i.content !== "Heading" && tempValues[i.fieldId])))
            setValue(tempValues);
        }

    },[])
    return(
        <>
            {editVal.map && editVal.map((i:any,index:number)=>{
//                 console.log("iWebFormFieldiWebFormField",i);
                return(
                    <React.Fragment key={index}> 
                        {i?.fieldType !== "Heading" && 
                        <Typography className='value_list_item' variant="body1">
                            <span>{i?.fieldLabel} </span>  
                            {i?.fieldType === "DatePicker" ? 
                                    <span>{":"} &nbsp; {value[i?.fieldId] ? ConvertZ(value[i?.fieldId]) :  "N/A"}</span>
                                :   <span>{":"} &nbsp; {value[i?.fieldId] || "N/A"}</span>
                            }
                        </Typography>
                        }
                    </React.Fragment>
                )
            })}
        </>
    )
}

export default WebFormValues